'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _BlockTypes = require('../constants/BlockTypes');
var _BlockTypes2 = _interopRequireDefault(_BlockTypes);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var styles = {
  globalBlock: {
    maxWidth: function maxWidth(_ref) {
      var siteMaxWidth = _ref.siteMaxWidth,
        bodyBlock = _ref.bodyBlock;
      return bodyBlock && siteMaxWidth;
    },
    margin: function margin(_ref2) {
      var siteMaxWidth = _ref2.siteMaxWidth;
      return !!siteMaxWidth && '0 auto';
    },
    wordBreak: 'break-word'
  }
};
var Block = function (_Component) {
  _inherits(Block, _Component);
  function Block() {
    var _ref3;
    var _temp, _this, _ret;
    _classCallCheck(this, Block);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = Block.__proto__ || Object.getPrototypeOf(Block)).call.apply(_ref3, [this].concat(args))), _this), _this.fetchPage = function (page, queryParams) {
      var _this$props = _this.props,
        blockType = _this$props.blockType,
        fetchData = _this$props.fetchData;
      fetchData(blockType.fetchPage(page, queryParams));
    }, _this.initCompleteFetchs = function () {
      var _this$props2 = _this.props,
        blockType = _this$props2.blockType,
        fetchData = _this$props2.fetchData;
      blockType.initCompleteFetchs.map(function (currentFetch) {
        fetchData(currentFetch());
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(Block, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
        blockType = _props.blockType,
        rootContentId = _props.rootContentId;
      if (blockType.fetchPage) {
        var extraParams = blockType.id === _BlockTypes.SPEAKERS ? {
          contentId: rootContentId
        } : undefined;
        this.fetchPage(null, extraParams);
      }
      if (blockType.initCompleteFetchs) this.initCompleteFetchs();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
        rootContentId = _props2.rootContentId,
        editable = _props2.editable,
        preview = _props2.preview,
        blockId = _props2.blockId,
        index = _props2.index,
        ContentClass = _props2.ContentClass,
        classes = _props2.classes;
      return _react2.default.createElement('div', {
        className: (0, _classnames2.default)("block", classes.globalBlock)
      }, _react2.default.createElement(ContentClass, {
        isRootContent: true,
        blockId: blockId,
        blockIndex: index,
        contentId: rootContentId,
        editable: editable,
        preview: preview,
        fetchPage: this.fetchPage,
        ContentClass: ContentClass
      }));
    }
  }]);
  return Block;
}(_react.Component);
var mapStateToProps = function mapStateToProps(_ref4, _ref5) {
  var blocks = _ref4.blocks;
  var blockId = _ref5.blockId;
  return {
    blockType: _BlockTypes2.default[blocks[blockId].type],
    rootContentId: blocks[blockId].rootContentId
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, state) {
  return {
    fetchData: function fetchData(action) {
      return dispatch(action);
    }
  };
};
Block.propTypes = {
  blockId: _propTypes2.default.string.isRequired,
  rootContentId: _propTypes2.default.string.isRequired,
  editable: _propTypes2.default.bool
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactJss2.default)(styles)(Block));